
/**
* 数字转整数 如 100000 转为10万
* @param {需要转化的数} num 
* @param {需要保留的小数位数} point 
*/
export const tranNumber = function (num, point) {
    let numStr = (num * 1).toString()
    // 十万以内直接返回 
    if (numStr.length < 6) {
        return numStr;
    }
    //大于8位数是亿
    else if (numStr.length > 8) {
        let decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point);
        return parseFloat(parseInt(num / 100000000) + '.' + decimal) + '亿';
    }
    //大于6位数是十万 (以10W分割 10W以下全部显示)
    else if (numStr.length > 5) {
        let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
        return parseFloat(parseInt(num / 10000) + '.' + decimal) + '万';
    }
}

export const sortHotFeed = function (data) {
    //var start = new Date(new Date().toLocaleDateString()).getTime()/1000; //当天0点时间戳 [秒]
    var dayArr = new Array();
    var newArr = new Array();
    var feedBuffer = new Object();
    var dayBuffer = new Array();
    var adArr = new Array();
    var feedArr = new Array();

    var typeArr = [1, 2, 3, 4];

    data.forEach(function (item) {
        if (typeArr.includes(item['article'])) {
            var key = item['article'] + '_' + item['modelId'];
            var createTime = timeStampToDate(item['created_at'], '-');
            var weeHours = new Date(new Date(createTime).toLocaleDateString()).getTime() / 1000;
            feedArr.push(item);
            feedBuffer[key] = item;
            dayArr.push(weeHours);
        } else {
            adArr.push(item);
        }
    });

    var trueDayArr = [...new Set(dayArr)];//数组去重
    // var trueDayArr = arrayNonRepeat(dayArr);
    quickSort(trueDayArr);
    trueDayArr.reverse();
    trueDayArr.forEach(function (value, index) {
        var tempArr = [value, []];
        dayBuffer.push(tempArr);
    });
    feedArr.forEach(function (item) {
        var curTime = timeStampToDate(item['created_at'], '-');
        var curHours = new Date(new Date(curTime).toLocaleDateString()).getTime() / 1000;
        var searchIndex = trueDayArr.indexOf(curHours);
        if (searchIndex != -1) {
            // console.log(searchIndex); readCount commentCount upCount fanCount
            var feedKey = item['article'] + '_' + item['modelId'];
            dayBuffer[searchIndex][1].push(feedBuffer[feedKey]);
        }
    });
    //console.log(dayBuffer);
    dayBuffer.forEach(function (day, index) {
        day[1].sort(function (a, b) {
            if (b['readCount'] == a['readCount']) {
                if (b['commentCount'] == a['commentCount']) {
                    if (b['upCount'] == a['upCount']) {
                        return b['fanCount'] - a['fanCount'];
                    } else {
                        return b['upCount'] - a['upCount'];
                    }
                } else {
                    return b['commentCount'] - a['commentCount'];
                }
            } else {
                return b['readCount'] - a['readCount'];
            }
        });
        // console.log(formatFeedTimeStamp(day[0]));
        day[1].forEach(function (item) {
            newArr.push(item);
        })
    });

    adArr.forEach(function (value, index) {
        var randomNum = randomNumber(4, 10);
        newArr.splice(randomNum, 0, value);
    });

    return newArr;
}

function randomNumber(minNum, maxNum) {
    switch (arguments.length) {
        case 1:
            return parseInt(Math.random() * minNum + 1, 10);
            break;
        case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            break;
        default:
            return 5;
            break;
    }
}

function timeStampToDate(time, separator) {
    if (!time)
        return '';
    var timeStamp = new Date(time * 1000);
    var year = timeStamp.getFullYear();
    var mou = timeStamp.getMonth() + 1;
    var day = timeStamp.getDate();
    day < 10 ? day = '0' + day : null;
    mou < 10 ? mou = '0' + mou : null;
    var newTime = year + separator + mou + separator + day;
    return newTime;
}

function quickSort(num) {
    _quickSort(num, 0, num.length - 1); // 将整个num数组快速排序，left和right分别指向数组左右两端。
}
/**
 * 快速排序(非递归)
 */

function _quickSort(num, left, right) {
    var list = [[left, right]]; // 将[left,right]存入数组中，类似于递归入栈
    while (list.length > 0) { // 若list不为空，循环弹出list最后一个数组进行快排
        var now = list.pop(); // 弹出list末尾。(也可用list.shift()取出list第一个数组，但在数据量较大时，这种方式效率较低)
        if (now[0] >= now[1]) { // 若左右指针相遇，待排序数组长度小于1，则无需进行快排(注意不能写成now[0]==now[1]，这里now[0]是有可能大于now[1]的
            continue;
        }
        var i = now[0], j = now[1], flag = now[0]; // 以下与递归方法相同，请参考上面的递归详解
        while (i < j) {
            while (num[j] >= num[flag] && j > flag) j--;
            if (i >= j) {
                break;
            }
            while (num[i] <= num[flag] && i < j) i++;
            let temp = num[flag];
            num[flag] = num[j];
            num[j] = num[i];
            num[i] = temp;
            flag = i;
        }
        list.push([now[0], flag - 1]); // 将flag左边数组作为待排序数组，只需将左右指针放入list即可。
        list.push([flag + 1, now[1]]); // 将flag右边数组作为待排序数组，只需将左右指针放入list即可。
    }
}

function arrayNonRepeat(arr) {
    let map = new Map();
    let array = new Array();  // 数组用于返回结果
    for (let i = 0; i < arr.length; i++) {
        if (map.has(arr[i])) {  // 如果有该key值
            map.set(arr[i], true);
        } else {
            map.set(arr[i], false);   // 如果没有该key值
            array.push(arr[i]);
        }
    }
    return array;
}

export const removeHTMLTag = function (str) {
    //去除HTML tag
    str = str.replace(/<\/?[^>]*>/g, '');
    //去除行尾空白
    str = str.replace(/[ | ]*\n/g, '\n');
    //去除多余空行
    //str = str.replace(/\n[\s| | ]*\r/g,'\n');
    str = str.replace(/&nbsp;/ig, '');
    return str;
}

export const sliceFeedContent = function (str) {
    if (str && str != "null") {
        // str = removeHTMLTag(str);
        str = htmlFilter(str);
        if (str.length > 0 && str.length < 75) {
            return str
        } else if (str.length > 74) {
            return str.slice(0, 75) + '……'
        }
    } else {
        return ""
    }
}

export const newFileName = function (oldName) {
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var charLength = chars.length - 1;
    var res = "";
    for (var i = 0; i < 32; i++) {
        var id = Math.ceil(Math.random() * charLength);
        res += chars[id];
    }
    var nameArr = oldName.split(".");
    let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
    var newName = loginUser.userId + "_" + res + new Date().getTime() + "." + nameArr.pop();
    return newName;
}

export const XXSFilter = function (val) {
    var str = '';
    if (val) {
        str = val.toString();
        str = str.replace(/[<]/g, "&lt;");
        str = str.replace(/[>]/g, "&gt;");
        str = str.replace(/[+]/g, "%2b");
        //str = str.replace(/"/g, "&quot;");
    }
    return str;
}

/* 将特殊字符转义成html字符实体 */
export const htmlEscape = function (text) {
    return text.replace(/[<>"&+]/g, function (match, pos, originalText) {
        switch (match) {
            case "<": return "&lt;";
            case ">": return "&gt;";
            case "&": return "&amp;";
            case "+": return "%2b";
            case "\"": return "&quot;";
        }
    });
}

/* 将html转义字符实体还原成字符本身 */
export const htmlFilter = function (text) {
    var str = "";
    if (text) {
        var matchList = {
            '&lt;': '<',
            '&gt;': '>',
            '&amp;': '&',
            '&#34;': '"',
            '&quot;': '"',
            '&#39;': "'",
        };
        let regStr = '(' + Object.keys(matchList).toString() + ')';
        regStr = regStr.replace(/,/g, ')|(');
        var regExp = new RegExp(regStr, 'g');
        str = text.replace(regExp, match => matchList[match]);
    }
    return str;
}

export const random = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export const birthToDate = function (time) {
    var timeStamp = new Date(time * 1000);
    var year = timeStamp.getFullYear();
    var mou = timeStamp.getMonth() + 1;
    var day = timeStamp.getDate();
    day < 10 ? day = '0' + day : null;
    mou < 10 ? mou = '0' + mou : null;
    year = year.toString();
    mou = mou.toString();
    day = day.toString();
    var newTime = year + mou + day;
    return newTime;
}

export const formatDeadKey = function (birthStr) {
    if (typeof birthStr == "number") {
        birthStr = birthStr.toString();
    }
    var birthArr = birthStr.split(".");
    var str = '';
    for (var i = 0; i < 3; i++) {
        // str += birthArr[i] ? birthArr[i] : '01';
        if (birthArr[i]) {
            if (birthArr[i].length < 2) {
                str += '01'
            } else {
                str += birthArr[i]
            }
        } else {
            str += '01'
        }
        // if (birthArr[i] && birthArr[i].length<2) {
        //     str +='01'
        // } else {
        //     str +=birthArr[i]
        // }
    }
    return str;
}

// 防抖
export function _debounce(fn, delay) {

    var delay = delay || 200;
    var timer;
    return function () {
        var th = this;
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn.apply(th, args);
        }, delay);
    };
}
// 节流
export function _throttle(fn, interval) {
    var last;
    var timer;
    var interval = interval || 200;
    return function () {
        var th = this;
        var args = arguments;
        var now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                fn.apply(th, args);
            }, interval);
        } else {
            last = now;
            fn.apply(th, args);
        }
    }
}

export const initAdminMessage = function (msgBody) {
    var tempArr = msgBody.split(":");
    var content = tempArr.pop();
    var str = '';
    if (content) {
        str = content.replace(/:/g, "");
        str = str.replace(/'/g, "");
        str = str.replace(/{/g, "");
        str = str.replace(/}/g, "");
    }
    return str;
}

export const isInternetUrl = function (urlStr) {
    // var match = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/;
    if (urlStr != "" && JSON.stringify(urlStr) !== "null") {
        return true
    }
    return false
};

export const initAdminMsgContent = function (type, originText) {
    switch (type) {
        case "1":
            return "身份证实名认证通知，请在手机端查验";
        case "2":
            return "赠送船票通知，请在手机端查收";
        case "3":
            return initAdminMessage(originText);//用户举报
        case "4":
            return "红包退款通知，请在手机端查收";
        case "6":
            return initAdminMessage(originText);//系统警告
        case "8":
            return "转账退款通知，请在手机端查收";
        case "40":
            return "购买船票通知，请在手机端查收";
        case "41":
            return "转账通知，请在手机端查收";
        case "42":
            return "出售船票通知，请在手机端查收";
        case "43":
            return "赠送船票通知，请在手机端查收";
        case "44":
            return "转账收款通知，请在手机端查收";
        case "45":
            return "红包收款通知，请在手机端查收";
        case "46":
            return "充值通知，请在手机端查收";
        case "101":
            return initAdminMessage(originText);//终端登录
        case "256":
            return "收到转账通知，请在手机端查收";
        case "272":
            return "收到船票通知，请在手机端查收";
        case "400":
            return "讣告取消通知，请在手机端查收";
        case "401":
            return "讣告通知，请在手机端查收";
        case "501":
            return initAdminMessage(originText);//同意复制家谱
        case "503":
            return initAdminMessage(originText);//断连成功
        case "504":
            return initAdminMessage(originText);//复制家谱成功
        default:
            return originText
    }
}
